// extracted by mini-css-extract-plugin
module.exports = {"header":"Retexes_header__hVHih","title":"Retexes_title__idvL9"};